import { CHECKBOX_RADIO_SIZE } from '../VBaseCheckboxRadio';
import { createTwStyle } from '../util';
import type { VInnerCheckboxProps } from './type';

const twStyle = createTwStyle<VInnerCheckboxProps>();

export default twStyle({
  icon: ({ disabled, size }) => [
    {
      'cursor-pointer': !disabled,
      'cursor-not-allowed text-gray-400': disabled,
      'size-4': size === CHECKBOX_RADIO_SIZE.SM,
      'size-5': size === CHECKBOX_RADIO_SIZE.MD,
      'size-6': size === CHECKBOX_RADIO_SIZE.LG,
    },
  ],
});
